import {Button, Carousel} from "antd";
import React from "react";

const HomePageCarousel = ({slides}) => {

    return slides ? (
        <Carousel autoplay>
            {slides.map((slide,i) => (
                <div key={i}>
                    <div className="carousel-slide">
                        <div className="carousel-slide-bg" style={{backgroundImage: `url(${slide.image})`}} />
                        <div className="carousel-slide-info flex-vertical-center">
                            <div>
                                <span className="carousel-slide-title">{slide.title}</span><br/>
                                <span className="carousel-slide-subtitle">{slide.subtitle}</span><br/>
                                <Button className="carousel-slide-button" href={slide.link_url}>{slide.link_text}</Button>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </Carousel>
    ) : (
        <div className="carousel-slide" >
            <div className="carousel-slide-bg" />
            <div className="carousel-slide-info flex-vertical-center" />
        </div>
    );
};

export default HomePageCarousel;